import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import './Contenido.css';
import { Button } from '../button';
import Portafolio2 from '../Portafolio2';
import CardItem from '../CardItem';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import {Helmet} from "react-helmet";

function Contenido () {
        const { Contenido } = useLocation();
  
        useEffect(() => {
          window.scrollTo(0, 0);
        }, [Contenido]);
      

    return (
        <>
        <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Creación de Contenido</title>
          <meta name="description" content= "Desarrollamos contenidos, narrativas y formatos listos para activar tu estrategia digital." />
          <meta name="robots" content= "index, follow"></meta>
        </Helmet>
       <div className='header'>
       
        <h1> Creación de Contenido</h1> 
      
        <p> Conectar, inspirar y convertir: todo empieza con una historia bien contada.</p> 
      
      
        </div>

        <div className='container'>
                  
                  <p>En Tekins integramos estrategia, creatividad y data para sostener tus canales digitales. Diseñamos contenido listo para activar campañas, nutrir comunidades y potenciar ventas.
                  </p>
               
                  <h2 >¿Cómo logramos la comunicación adecuada?</h2>
                   <p>Investigamos tu marca, mapeamos audiencias y definimos mensajes clave. Luego activamos un calendario modular con formatos estáticos, animados y video listos para publicar.
                      </p>
  </div>

       <div className='content-pack'>
<div className=' row-pack-01'>

        <div className='col-pack-01'>
        <div className='imagen-pack-row-c'> 
                <img class="imagen-pack-row-1" 
                src="https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=900&q=80" 
                alt="Equipo creativo trabajando"/>
         </div>
        </div>
        <div className='col-pack-01-r'>
        <div className='col-title'>
            <h1> Pack 1</h1> 
            </div>
                    <div className='col-content'>   
                    <ul>
                    <li>Diseño y estilo de feed.</li>
                    <li>Biografía optimizada para Instagram y LinkedIn.</li>
                    <li>5 Highlights.</li>
                    <li>9 Post mensuales. (2 carruseles)</li>
                    <li>10 Stories para Instagram.</li>
                    <li>1 Banner para Facebook.</li>
                    </ul>
                    <p>La publicación queda a cargo del cliente con guía de mejores prácticas incluida.</p>
                    </div>
                    <div className='col-time'>   
                    <h4></h4>
                    </div>
                    
                    <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20el%20Pack%201%20de%20Tekins"> <button className='bt' >Comprar</button> </a></div>
                    
            
        </div>
</div>





        <div className='row-pack-02'>
        <div className='col-pack-02'>
                        <div className='col-title'>
                                <h1> Pack 2</h1> 
                        </div>
                    <div className='col-content'>   
                    <ul>
                    <li>1 videollamada para asesorarte en los primeros pasos</li>
                    <li>Diseño y estilo de feed.</li>
                    <li>Biografía optimizada para Instagram y LinkedIn.</li>
                    <li>6 Highlights.</li>
                    <li>12 Post mensuales. (3 carruseles)</li>
                    <li>10 Stories para Instagram y secuencia de Reels.</li>
                    <li>Desarrollo de contenido.</li>
                    <li>12 copys listos para publicar.</li>
                    </ul>
                    <p>Incluye guía para programar contenidos y checklist de publicación.</p>
                    </div>
                    <div className='col-time'>   
                    <h4></h4>
                                        </div>
                    <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20el%20Pack%202%20de%20Tekins"> <button className='bt' >Comprar</button> </a></div>
                          
        </div>
        <div className='col-pack-02-r'>
        <div className='imagen-pack-row-c'> 
                <img class="imagen-pack-row-2" 
                src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80" 
                alt="Creación de contenido digital"/>
         </div>
        </div>
        </div>

        <div className=' row-pack-01'>

<div className='col-pack-01'>
<div className='imagen-pack-row-c'> 
        <img class="imagen-pack-row-1" 
        src="https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=900&q=80" 
        alt="Producción multimedia Tekins"/>
 </div>
</div>
<div className='col-pack-01-r'>
<div className='col-title'>
    <h1> Pack 3</h1> 
    </div>
            <div className='col-content'>   
            <ul>
                    <li>1 videollamada mensual</li>
                    <li>Diseño y estilo de feed.</li>
                    <li>Biografía optimizada para Instagram y LinkedIn.</li>
                    <li>6 Highlights.</li>
                    <li>20 Post mensuales. (3 carruseles)</li>
                    <li>15 Stories para Instagram y 3 Reels guionizados.</li>
                    <li>1 Banner para Facebook.</li>
                    <li>Desarrollo de contenido.</li>
                    <li>20 copys listos para publicar.</li>
                    </ul>
                    <p>Entregamos guía de calendarización y recursos editables.</p>
                    </div>
                    <div className='col-time'>   
                    <h4></h4>
                    </div>
            
                    <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20el%20Pack%203%20de%20Tekins"> <button className='bt' >Comprar</button> </a></div>
            
    
</div>


</div>

<div className='row-pack-02'>
        <div className='col-pack-02'>
                        <div className='col-title'>
                                <h1> Pack 4</h1> 
                        </div>
                    <div className='col-content'>   
                    <ul>
                    <li>1 videollamada mensual</li>
                    <li>Diseño y estilo de feed.</li>
                    <li>Biografía optimizada para Instagram y LinkedIn.</li>
                    <li>6 Highlights.</li>
                    <li>30 Post mensuales. (5 carruseles)</li>
                    <li>Stories para Instagram, Reels y Shorts.</li>
                    <li>Desarrollo de contenido.</li>
                    <li>30 copys listos para publicar.</li>
                    <li>Producción fotográfica exterior o en estudio.</li>
                    <li>Gestión integral de la plataforma.</li>
                    <li>Respuesta a comentarios y monitoreo activo.</li>
                    <li>1 Banner para Facebook.</li>
                    </ul>
                    
                    </div>
                    <div className='col-time'>   
                    
                    </div>
                    <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20cotizar%20el%20Pack%204%20de%20Tekins"> <button className='bt' >Cotizar</button> </a></div>
                          
        </div>
        <div className='col-pack-02-r'>
        <div className='imagen-pack-row-c'> 
                <img class="imagen-pack-row-4" 
                src="https://images.unsplash.com/photo-1529429617124-aee72d04d01b?auto=format&fit=crop&w=900&q=80" 
                alt="Gestión de redes Tekins"/>
         </div>
        </div>
        </div>
        <div className='container-02'>
        <h2 >Importante</h2>
                  <p>Entregamos cada pieza en el orden recomendado para mantener consistencia visual.
Si necesitas el contenido en plantillas editables podemos prepararlas en Illustrator, Photoshop o Figma.
Recordemos que una marca sólida no solo vende; conversa, inspira y crea comunidad con contenidos coherentes.  
 </p>
                   
 <div className='row-button-home'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20cotizar%20los%20servicios%20de%20contenido%20de%20Tekins"> <button className='bt' >Cotizar</button> </a></div>
       
  </div>
        </div>

<div className='portafolio-contenido'>
        <div className='cards__container'>
        <div className='cards__wrapper'>
           <ul className='cards__items'>
           <CardItem
              src='images/santarita-01.jpg'
              text='Santa Rita'
              
              path='/Santarita'
            />
         
         
          <CardItem
              src='images/mercadovera-01.jpg'
              text='Mercado de Vera'
              
              path='/Mercadodevera'
            />
            <CardItem
              src='images/photozulem-01.jpg'
              text='Katherine Zulem'
             
              path='/Photozulem'
            />
           <CardItem
              src='images/zulemevent-01.jpg'
              text='Zulem Events'
              
              path='/Zulemevents'
            />
            <CardItem
              src='images/azucenas-01.jpg'
              text='Azucena’s'
             
              path='/Azucenas'
            />
          </ul>
          </div>
          </div>
</div>
        <Footer/>
        </>
    );
}

export default Contenido;
